import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '@/lib/query-client';
import { AuthProvider } from '@/contexts/AuthContext';
import { ThemeProvider } from '@/contexts/ThemeContext';
import { AppRouter } from '@/router';
import { Analytics } from '@/services/analytics.service';

// Initialize analytics once on module load. trackFirstVisit() must run after
// initialize() so isReady() is true; the emitted event buffers and flushes
// onto the correct distinct_id after identify() completes.
Analytics.initialize();
Analytics.trackFirstVisit();

export default function App() {
  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
}
